import React,{useRef,useState,useEffect} from 'react';
import styled from 'styled-components'
import {Typing} from 'typing-effect-reactjs'

const Article4Block = styled.div`
  position: relative;
    .linkPaper {
      position: absolute;
      bottom: -17px; left: 0;
      width: 100%;
    }
  .listOut {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.6);
    }
    .list {
      width: 25%;
      background-position: center;
      background-size: cover;
    }
    .listBox1{
      background-image:url(images/list1.jpg);
    }
    .listBox2{
      background-image:url(images/list2.jpg);
    }
    .listBox3{
      background-image:url(images/list3.jpg);
    }
    .listBox4{
      background-image:url(images/list4.jpg);
    }
    .textArea {
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      font-size: 120px;
      font-family: 'Josefin Sans';
      p {
        font-size: 70px;
        margin-bottom: 30px ;
      }
    }
  }
  
`;

const Article4 = () => {

  const art4ref = useRef()
  const [scy,setScy] = useState()
  const [on,setOn] = useState(false)
  const text = [
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
    'TEES?','SWEATS?','PANTS?','SHORTS?','OUTWEAR?','ACCESSORIES?',
  ]
  
  return (
    <Article4Block ref={art4ref}>
      <div  className='listOut'>
        <div className='list listBox1'>
        </div>
        <div className='list listBox2'>
        </div>
        <div className='list listBox3'>
        </div>
        <div className='list listBox4'>
        </div>
        <div className='textArea'>
          <p>What you like?</p>
          <Typing
            text={text}
            typeSpeed={200}
            deleteSpeed={100}
            disableBlinkingOnEnd={false}
            blinkingSpeed={0}
            smartBackspace={true}
            cursorColor={'white'}
          />
        </div>
      </div>
      <img className='linkPaper' src="images/link_paper.png" alt='연결'/>
    </Article4Block>
  );
};

export default Article4;